// src/utils/geolocalizacaoUtils.js

const CHAVE_LOCALIZACAO = 'localizacaoInput';

const MENSAGENS_ERRO_GEOLOCALIZACAO = {
  1: 'Permissão de localização negada. Libere o acesso à localização nas configurações do navegador e tente novamente.',
  2: 'Não foi possível identificar sua localização. Verifique se o GPS está ativado.',
  3: 'A localização demorou para responder. Tente novamente em um local com melhor sinal.',
};

export const geolocalizacaoDisponivel = () =>
  typeof navigator !== 'undefined' && !!navigator.geolocation;

export const obterMensagemErroGeolocalizacao = (erro) =>
  MENSAGENS_ERRO_GEOLOCALIZACAO[erro?.code] || erro?.message || 'Não foi possível obter sua localização.';

// Solicita a posição atual do dispositivo (o navegador pede permissão ao usuário).
export const obterPosicaoAtual = (opcoes = {}) => new Promise((resolve, reject) => {
  if (!geolocalizacaoDisponivel()) {
    reject(new Error('Seu dispositivo ou navegador não permite obter a localização.'));
    return;
  }

  if (typeof window !== 'undefined' && window.isSecureContext === false) {
    reject(new Error('A localização só pode ser usada em conexão segura (https).'));
    return;
  }

  navigator.geolocation.getCurrentPosition(
    (posicao) => resolve({
      latitude: posicao.coords.latitude,
      longitude: posicao.coords.longitude,
      precisao: posicao.coords.accuracy,
    }),
    (erro) => reject(new Error(obterMensagemErroGeolocalizacao(erro))),
    { enableHighAccuracy: true, timeout: 15000, maximumAge: 0, ...opcoes },
  );
});

const formatarCoordenada = (valor) => Number(Number(valor).toFixed(6)).toString();

// Mesmo formato gerado no backend (LocalizacaoHelper.MontarLink).
export const montarLinkLocalizacao = (latitude, longitude) =>
  `https://www.google.com/maps/search/?api=1&query=${formatarCoordenada(latitude)},${formatarCoordenada(longitude)}`;

export const lerLocalizacaoSalva = () => {
  try {
    const salva = JSON.parse(localStorage.getItem(CHAVE_LOCALIZACAO));
    if (salva && Number.isFinite(Number(salva.latitude)) && Number.isFinite(Number(salva.longitude)) && salva.localizacao) {
      return { latitude: Number(salva.latitude), longitude: Number(salva.longitude), localizacao: salva.localizacao };
    }
  } catch (erro) {
    // valor inválido no localStorage: descarta abaixo
  }
  localStorage.removeItem(CHAVE_LOCALIZACAO);
  return null;
};

export const salvarLocalizacao = (localizacao) => {
  if (localizacao?.localizacao) {
    localStorage.setItem(CHAVE_LOCALIZACAO, JSON.stringify({
      latitude: localizacao.latitude,
      longitude: localizacao.longitude,
      localizacao: localizacao.localizacao,
    }));
  } else {
    localStorage.removeItem(CHAVE_LOCALIZACAO);
  }
};
